import React from 'react';
import { TSStateProvider } from './TSContext';
import TSInterface from './interface/TSInterface';
import TextSelectionListener from './interface/TextSelectionListener';
import './ts-styles.css';
const TSWidget = ({ test }) => {
    return (React.createElement(TSStateProvider, null,
        React.createElement(TSInterface, null),
        React.createElement(TextSelectionListener, null)));
};
export default TSWidget;
